import { useState } from 'react'
import type { Item } from 'typings'
import { useFetch } from './useFetch'
import { assertFulfilled } from './utils'

type BrandResponse = {
  id: number
  name: string
}

export function useBrandsImport() {
  const [loading, setLoading] = useState(false)

  const { fetcherWrapper } = useFetch()

  function getBrand(id: string): Promise<Item> {
    const url = new URL(
      `/api/proxy/catalog_system/pvt/brand/${id}`,
      window.location.origin
    )

    return fetcherWrapper(url)
      .then((r) => {
        if (r.status === 404) return Promise.reject('Not found')
        if (!r.ok) return Promise.reject('Error retrieving brands')

        return r.json()
      })
      .then((response: BrandResponse) => ({
        id: response.id.toString(),
        name: response.name,
      }))
  }

  async function importBrands(
    ids: string[]
  ): Promise<{ items: Item[]; found: number; notFound: number }> {
    setLoading(true)

    const promises = ids.map((id) => getBrand(id))

    const brands = await Promise.allSettled(promises).then((resuls) => {
      return resuls.filter(assertFulfilled).map((r) => r.value)
    })

    setLoading(false)

    return {
      found: brands.length,
      notFound: brands.length - brands.length,
      items: brands,
    }
  }

  return { importBrands, loading }
}
